export const IMAGES_BASE_URL = "https://null-leasing-pages.s3.eu-central-1.amazonaws.com";

export default {
  IMAGES_BASE_URL,
};
